import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppState } from '@core/store/app.reducer';
import { selectLoginUserInfo } from '@core/store/app.selectors';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { ClientDataModalComponent } from '../modals/client-data-modal/client-data-modal.component';
import { LocalStorageService } from '@core/services/local-storage.service';

@Component({
  selector: 'app-menu-responsive',
  templateUrl: './menu-responsive.component.html',
  styleUrls: ['./menu-responsive.component.scss'],
})
export class MenuResponsiveComponent implements OnInit {
  @Input() optionsMenu: any;
  @Output() closeDialogemit = new EventEmitter<string>();
  settingClientSuscription$!: Subscription;
  settingClient: any;
  constructor(
    public readonly clientDataModal: MatDialog,
    private readonly router: Router,
    private readonly store: Store<AppState>,
    private readonly _localStorageService: LocalStorageService,
  ) { }

  ngOnInit() {
    this.getSettingClient();
  }
  closeDialog() {
    this.closeDialogemit.emit('');
  }
  getSettingClient() {
    this.unsubscribeFromStore();
    this.settingClientSuscription$ = this.store
      .pipe(select(selectLoginUserInfo))
      .subscribe((value) => {
        this.settingClient = value.setting;
        this.optionsMenu.find(
          (option) => option.label === 'Avance de ventas'
        ).show = this.settingClient.isAdvance;

        // Verifica el valor de isBenefit y cambia show en consecuencia
        this.optionsMenu.find(
          (option) => option.label === 'Reconocimientos'
        ).show = this.settingClient.isBenefit;
        const alliesSector = this._localStorageService.getItem('clientSelect')?.sector
          ?? this._localStorageService.getItem('sectorSelect')?.sector;
        this.optionsMenu.find((option) => option.label === 'Aliados Puntos').show =
          this.settingClient.isAlly && alliesSector == '0010';
          
        this.optionsMenu.find(
          (option) => option.label === 'Aliados Beneficios'
        ).show = (this.settingClient?.isPartner && this._localStorageService.getItem('clientSelect')?.sector == '0010');

      });
  }
  action(option: any) {
    switch (option.label) {
      case 'Datos del cliente':
        const dialogRef = this.clientDataModal.open(ClientDataModalComponent, {
          width: '398px',
          height: '44rem',
          maxWidth: '90vw',
          data: {},
        });
        dialogRef.afterClosed().subscribe((data: any) => {
          if (data?.status) {
            // console.log(data);
          }
        });
        break;

      case 'Historial de compras':
        this.router.navigate(['/main/historial-compras']);
        break;
      case 'Cuenta corriente':
        this.router.navigate(['/main/cuenta-corriente']);
        break;
      case 'Facturas':
        window.open('http://asp401r.paperless.com.pe/PortalAlicorp/', '_blank', 'noopener');
        break;
 case 'Mis Reclamos':
        this.router.navigate(['/main/mis-reclamos']);
        break;
      case 'Subir pedido':
        this.router.navigate(['/main/subir-pedido']);
        break;
      case 'Avance de ventas':
        this.router.navigate(['/main/avances-ventas']);
        break;
      case 'Reconocimientos':
        this.router.navigate(['/main/reconocimientosdetalle']);
        break;
      case 'Inicio':
        this.router.navigate(['/main/inicio']);
        break;
      case 'Aliados Puntos':
        this.router.navigate(['/main/aliados']);
        break;
      case 'Aliados Beneficios':
        this.router.navigate(['/main/ali-socios']);
        break;
      case 'Imperdonables':
        this.router.navigate(['/main/los-infaltables'], { queryParams: { tab: 'imperdonables' } });
        break;
      case 'Infaltables':
        this.router.navigate(['/main/los-infaltables'], { queryParams: { tab: 'infaltables' } });
        break;
      default:
        break;
    }
  }
  unsubscribeFromStore() {
    if (this.settingClientSuscription$) {
      this.settingClientSuscription$.unsubscribe();
    }
  }
  ngOnDestroy(): void {
    this.settingClientSuscription$.unsubscribe();
  }
}
